// extracted by mini-css-extract-plugin
module.exports = {"article":"article_article__ehaiy","articleText":"article_articleText__L37Fe","plainBox":"article_plainBox__xysOE"};